<div class="flex flex-col gap-3">
  <!-- podcast feed input -->
  <div>
    <div class="font-bold">
      {{ podcastFeedIndex + 1 }}.
      <span class="ml-[2px]"> {{ 'podcast-config.feed-link' | translate }}</span>
    </div>
    <rk-form-field [showError]="hasError">
      <div class="relative flex items-center group">
        <!-- text input -->
        <input
          class="mt-3 mb-1 w-full"
          [formControl]="podcastFeedControl"
          (input)="onPodcastFeedUrlChange()"
        />
        <!-- @if (hasError) {
          <fa-icon
            icon="exclamation-circle"
            class="text-xl absolute text-error opacity-40 right-4 top-[18px]"
          ></fa-icon>
        } -->
        @if (
          (podcastFeedControl.value === '' && podcastFeedControl.touched) ||
          hasError ||
          isDuplicate
        ) {
          <!-- delete button -->
          <rk-button
            variant="delete"
            size="small"
            [iconOnly]="true"
            [icon]="'trash-alt'"
            (buttonClick)="onDeleteClick()"
            class="absolute right-4 opacity-0 top-[18px] group-hover:opacity-100 transition-opacity duration-200"
          >
          </rk-button>
        }
      </div>

      @if (hasError) {
        <div class="form-error-message">
          {{ 'podcast-config.invalid' | translate }}
        </div>
      }

      <!-- duplicate warning message -->
      @if (isDuplicate && !hasError) {
        <div class="text-warning text-xs">
          <fa-icon icon="exclamation-triangle" class="text-warning mr-1"></fa-icon>
          {{ 'podcast-config.duplicate' | translate }}
        </div>
      }
    </rk-form-field>
  </div>

  <!-- podcast card (only show if URL is provided and valid) -->
  @if (
    podcastFeedControl.value &&
    podcastFeedControl.value !== '' &&
    !hasError &&
    !isDuplicate
  ) {
    <div class="h-[71px]">
      <!-- loader -->
      @if (isLoading) {
        <div class="flex-1 flex items-center justify-center py-8">
          <mat-progress-spinner
            mode="indeterminate"
            [strokeWidth]="2"
            [diameter]="24"
          ></mat-progress-spinner>
        </div>
      } @else {
        <div
          class="group flex flex-row gap-3 h-[71px] items-center justify-start pl-1 pr-4 py-1 relative rounded border border-black/10 border-solid transition-all duration-200 hover:border-gray-300/30 cursor-pointer w-full"
        >
          @if (podcastData | async; as podcast) {
            <!-- podcast image -->
            <div class="flex-shrink-0 w-[61px] h-[61px]">
              <img
                [src]="podcast?.logo || (currentAppConfigDefaultCover$ | async)"
                [alt]="podcast?.title"
                class="w-full h-full object-cover rounded"
              />
            </div>

            <!-- podcast info -->
            <div class="flex flex-col items-start justify-center gap-1 w-full truncate">
              <h4 class="podcast-title font-bold text-xl truncate w-full">
                {{ podcast?.title }}
              </h4>
              <p class="opacity-70">
                {{ podcast?.itemCount }}
                {{ 'podcast-config.episodes' | translate }}
              </p>
            </div>

            <!-- delete button -->
            <rk-button
              variant="delete"
              size="small"
              [iconOnly]="true"
              [icon]="'trash-alt'"
              (buttonClick)="onDeleteClick()"
              class="absolute right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            >
            </rk-button>
          }
        </div>
      }
    </div>
  }
</div>
